module.exports = __webpack_public_path__ + "static/media/night10.4223617a.jpg";